import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PersonalManager } from '@models/personal-manager.model';
import { WINDOW } from '@services';
import { cleanPhone } from '@shared/utils/helpers.util';

@Component({
  selector: 'app-personal-manager-popup',
  templateUrl: './personal-manager-popup.component.html',
  styleUrls: ['./personal-manager-popup.component.scss'],
})
export class PersonalManagerPopupComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { personalManager: PersonalManager },
    @Inject(WINDOW) private window: Window,
    public dialogRef: MatDialogRef<PersonalManagerPopupComponent>,
  ) {
    this.personalManager = data.personalManager;
  }

  private _personalManager: PersonalManager = null;

  set personalManager(personalManager: PersonalManager) {
    if (!!personalManager && this.checkPersonalManager(personalManager)) {
      this._personalManager = personalManager;
    } else {
      this._personalManager = null;
    }
  }

  get personalManager(): PersonalManager {
    return this._personalManager;
  }

  get name(): string {
    return `${this.personalManager.LastName || ''} ${this.personalManager.FirstName || ''} ${this.personalManager.MiddleName || ''}`;
  }

  get telToCopy(): string {
    return cleanPhone(this.personalManager.Phone || '');
  }

  get tel(): string {
    return `tel:${this.telToCopy}`;
  }

  get mailTo(): string {
    return `mailto:${this.personalManager.EMail || ''}`;
  }

  goTo(url: string): void {
    this.window.open(url, '_blank');
  }

  protected checkPersonalManager(personalManager: PersonalManager): boolean {
    return !!personalManager && !!personalManager.Ref && !!personalManager.EMail && !!personalManager.Phone;
  }
}
